/*
 * @providesModule StaticWarningModalStyle
 * 
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet,
} from 'react-native';

const width = Sizes.screenWidth;

const {
  fontRegular,
  fontBold,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  btnTextColorOne,
  viewDividerColorTwo,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  cellIcon: {
    height: Sizes.select({
      smallPhone: 40,
      largePhone: 50,
      portraitTablet: 75,
      landscapeTablet: 100,
    }),
    width: Sizes.select({
      smallPhone: 100,
      largePhone: 110,
      portraitTablet: 150,
      landscapeTablet: 170,
    }),
    alignSelf: 'center',
  },

  icon: {
    height: Sizes.select({
      smallPhone: 40,
      largePhone: 50,
      portraitTablet: 75,
      landscapeTablet: 100,
    }),
    width: Sizes.select({
      smallPhone: 40,
      largePhone: 50,
      portraitTablet: 75,
      landscapeTablet: 100,
    }),
    alignSelf: 'center',
  },

  screenContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },

  contentContainer: {
    backgroundColor: 'white',
    width: width,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 0,
  },

  title: {
    ...Sizes.select({
      smallPhone: fontSizeH4,
      largePhone: fontSizeH3,
      landscapeTablet: fontSizeH2,
      portraitTablet: fontSizeH1,
    }),
    ...fontBold,
    color: '#4A4A4A',
    textAlign: 'center',
    paddingHorizontal: 10,
  },

  message: {
    ...Sizes.select({
      smallPhone: fontSizeH4,
      largePhone: fontSizeH3,
      landscapeTablet: fontSizeH2,
      portraitTablet: fontSizeH1,
    }),
    ...fontRegular,
    color: '#4A4A4A',
    paddingVertical: 20,
    paddingHorizontal: 40,
    textAlign: 'center',
  },

  divider: {
    ...viewDividerColorTwo,
    height: 1,
    alignSelf: 'stretch',
    marginHorizontal: 50,
    top: 15,
    zIndex: 1,
  },

  buttonText: {
    ...fontBold,
    ...fontSizeH4,
    ...btnTextColorOne,
  },

  CTAButton: {
    width: 120,
    height: 35,
  },

  CTAButtons: {
    width: 160,
    height: 35,
    paddingHorizontal: 8,
  },

  buttonContainer: {
    width: width,
    flexDirection: 'row',
    justifyContent: 'center',
  },
});
